import React from "react";
import { connect } from "react-redux";
import "./style.css";
import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";

export const FoterMini = () => {
  const year = new Date().getFullYear();
  return (
    <div className="footer-v2__bar dealers-footer-v2__bar">
      <div className="footer-v2__bar-inner dealers-footer-v2__bar-inner">
        <div className="footer-v2__copy">
          © {year} AutoTrade Port · Dealers. All rights reserved.
        </div>
        <div className="footer-v2__social pi-footer__social">
          <a
            className="footer-v2__social-link pi-footer__social-link"
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookSquare size={18} />
          </a>
          <a
            className="footer-v2__social-link pi-footer__social-link"
            href="https://www.youtube.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <FaYoutube size={18} />
          </a>
          <a
            className="footer-v2__social-link pi-footer__social-link"
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin size={18} />
          </a>
          <a
            className="footer-v2__social-link pi-footer__social-link"
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram size={18} />
          </a>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});
export default connect(mapStateToProps, null)(FoterMini);
